module.exports = __webpack_public_path__ + "img/programme4.5123f0d6.png";